<template>
  <v-row class="flex-column mb-3" no-gutters>
    <v-col>
      <span class="text-caption"> {{ title }} </span>
    </v-col>
    <v-col>
      <slot>
        <span class="text-subtitle-1 text-center" :class="{ 'font-weight-medium': bold }" v-text="content" />
      </slot>
    </v-col>

    <v-col v-if="!noDivider" cols="12" class="d-flex">
      <v-divider />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ChoosenTicketCardItem",

  props: {
    bold: {
      type: Boolean,
      default: false,
    },
    noDivider: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: undefined,
    },
  },
});
</script>
